import { sv } from 'date-fns/locale';

export const svExtended = {
    ...sv,
    localize: {
        ...sv.localize,
        day: (n) => {
            const weekdays = ['Sön', 'Mån', 'Tis', 'Ons', 'Tors', 'Fre', 'Lör'];
            return weekdays[n];
        }
    }
};
